export function nodeListToArray(nodeList: NodeList) {
    return Array.prototype.slice.call(nodeList);
}